import React from 'react';
import { FormattedMessage } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

interface InconsistentValueProps {
    children: React.ReactNode;
    tooltipKey: string;
}

/** Struck-through content with an info tooltip, shown when the backend flags a due value inconsistent. */
export const InconsistentValue = ({ children, tooltipKey }: InconsistentValueProps) => (
    <OverlayTrigger
        placement={Tooltip.TOP}
        overlay={
            <Tooltip width={300}>
                <FormattedMessage id={tooltipKey} />
            </Tooltip>
        }
    >
        <span className="text-decoration-line-through">
            {children}
            <span className="rioglyph rioglyph-exclamation-sign text-color-dark text-size-16 width-auto margin-top-0" />
        </span>
    </OverlayTrigger>
);
